import SVG from "commons/styles/svgIcon";
import styled from "styled-components";
import { Text } from "styles/components";

const PageContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ErrorIcon = styled.div`
  margin: 0 auto;
  width: 230px;
  height: 230px;
  background: url(${SVG.Warning("#8e8e8e")}) no-repeat center center;
  background-size: 220px;
`;

export type INotFoundProps = {
  //NOTE: 무언가 Props 받을일이 생길때 쓸려고 만들어 둠.
};

function NotFound(): JSX.Element {
  return (
    <PageContainer>
      <ErrorIcon />
      <Text size="lg" align="center">
        요청한 페이지가 없거나 찾을 수 없습니다.
      </Text>
    </PageContainer>
  );
}

export default NotFound;
